<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>
<div class="pkg_status_wrap row float-right">
  <div class="col-md-7 part_current_status text-right">{{'PACKAGEID' | translate}}:
    <span class="status_review">{{routePackageID}}</span>
  </div>
  <div class="col-md-5 part_current_status">{{'STATUS' | translate}}:
    <span class="status_review" [ngClass]="{rejected:'red_alert',rejectedAndClosed:'red_alert'}[overAllPackageIDStatus]">{{displayOverallStatus}}</span>
  </div>
</div>
<form [formGroup]="supplyInfoForm" #f="ngForm" novalidate>
  <!-- <p>Is "supplyInfoForm" valid? {{supplyInfoForm.valid}}</p> -->
  <section class="global_part_info pad-top-40 no-mar-lr pad-btm-20 pad-lr-30">
    <div class="row">
      <div class="col-md-3">
        <div class="form-group row">
          <label for="" class="col-sm-4 col-form-label">{{'PARTNUMBER' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-sm-8">
            <input type="text" class="form-control" formControlName="partNumber">
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group row">
          <label for="partName" class="col-sm-4 col-form-label">{{'PARTNAME' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-sm-8">
            <input type="text" class="form-control" formControlName="partName">
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group row">
          <label for="supplierCode" class="col-sm-4 col-form-label">{{'SUPPLIERCODE' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-sm-8">
            <input type="text" class="form-control" formControlName="supplierCode">
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group row">
          <label for="delPlantName" class="col-sm-4 col-form-label">{{'SPNAME' | translate}}</label>
          <div class="col-sm-8">
            <select class="form-control" formControlName="supplySpName">
              <option value="">Select</option>
              <option *ngFor="let opt of serviceProviderNames" [value]="opt">{{opt}}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Show this section only for logisitics not for other users -->
  <section class="pad-lr-30 mar-top-20" *ngIf="userRoleId == 3">
    <div class="row mar-top-50">
      <div class="col-md-4">
        <div class="form-group row" [ngClass]="{'has-error': supplyInfoForm.get('supplyRegion').invalid && f.submitted }">
          <label for="" class="col-sm-6 col-form-label">{{'REGION' | translate}}
            <!-- <span class="required">*</span> -->
          </label>
          <div class="col-sm-6">
            <select class="form-control" formControlName="supplyRegion">
              <option value="">Select</option>
              <option *ngFor="let n of regionOpt" [value]="n">{{n}}</option>
            </select>
            <errors [control]="supplyInfoForm.controls.supplyRegion"></errors>
            <!-- <div *ngIf="supplyInfoForm.get('supplyRegion').invalid && f.submitted" class="required-error">{{'FieldRequired'
              | translate}}</div> -->
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group row" [ngClass]="{'has-error': supplyInfoForm.get('supplyTransportName').invalid && f.submitted }">
          <label for="" class="col-sm-6 col-form-label">{{'TRANSPORTMODE' | translate}}
            <span class="required" *ngIf="transportModeRequired">*</span>
          </label>
          <div class="col-sm-6">
            <select class="form-control" formControlName="supplyTransportName">
              <option value="">Select</option>
              <option *ngFor="let n of transportOpt" [value]="n">{{n}}</option>
            </select>
            <errors [control]="supplyInfoForm.controls.supplyTransportName"></errors>
            <div *ngIf="supplyInfoForm.get('supplyTransportName').invalid && f.submitted" class="required-error">{{'FieldRequired'
              | translate}}</div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group row" [ngClass]="{'has-error': supplyInfoForm.get('supplyContract').invalid && f.submitted }">
          <label for="" class="col-sm-6 col-form-label">{{'CONTRACT' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-sm-6">
            <select #contractType [(ngModel)]="contractTypeOption" (change)="onContractSelect(contractType.value)" class="form-control" formControlName="supplyContract">
              <option value="">Select</option>
              <option *ngFor="let n of contractOpt" [value]="n">{{n}}</option>
            </select>
            <errors [control]="supplyInfoForm.controls.supplyContract"></errors>
            <div *ngIf="supplyInfoForm.get('supplyContract').invalid && f.submitted" class="required-error">{{'FieldRequired'
              | translate}}</div>
          </div>
        </div>
      </div>
    </div>

  </section>

  <section class="pad-lr-30 mar-top-20">
    <div class="dta_title">{{'SUPPLIERINFO' | translate}}</div>
    <div class="dta_title_brd1"></div>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group row pad-tb-10">
          <label for="" class="col-sm-6 col-form-label">{{'SUPPNAME[Eng]' | translate}}</label>
          <div class="col-sm-6">
            <input type="text" class="form-control" formControlName="supplierNameEng">
            <errors [control]="supplyInfoForm.controls.supplierNameEng"></errors>
          </div>
        </div>
        <div class="dta_sub_title pad-btm-10">{{'PRODPOINT' | translate}}</div>
        <div class="form-group row">
          <label for="" class="col-sm-6 col-form-label">{{'NAME' | translate}}</label>
          <div class="col-sm-6">
            <input type="text" class="form-control" formControlName="supplierName">
            <errors [control]="supplyInfoForm.controls.supplierName"></errors>
          </div>
        </div>
        <div class="form-group row" [ngClass]="{'has-error': supplyInfoForm.get('supplierCountry').invalid && f.submitted }">
          <label for="delPlantName" class="col-sm-6 col-form-label">{{'COUNTRY' | translate}}
            <span class="required">*</span>

          </label>
          <div class="col-sm-6">
            <select class="form-control" formControlName="supplierCountry">
              <option value="" selected>Select</option>
              <option *ngFor="let n of country" [value]="n.name">{{n.name}}</option>
            </select>
            <errors [control]="supplyInfoForm.controls.supplierCountry"></errors>
            <div *ngIf="supplyInfoForm.get('supplierCountry').invalid && f.submitted" class="required-error">{{'FieldRequired'
              | translate}}</div>
          </div>
        </div>

        <div *ngIf="japanSelected == false || japanSelected == undefined" class="form-group row" [ngClass]="{'has-error': (supplyInfoForm.get('japanZipcode').invalid  && f.submitted)}">
          <label for="delPlantName" class="col-sm-6 col-form-label">{{'ZIPCODE' | translate}}
            <!-- <span class="required">*</span> -->
          </label>
          <div class="col-sm-6">
            <input type="text" class="form-control" formControlName="japanZipcode" maxlength="12" placeholder="{{'Enter Zip code' | translate}}">
            <!-- <div *ngIf="supplyInfoForm.controls.japanZipcode.invalid && (supplyInfoForm.controls.japanZipcode.dirty || supplyInfoForm.controls.japanZipcode.touched) && japanSelected == false && noValue == false"
              class="required-error">{{'Zipcode should be 7 digits' | translate}}</div> -->
          </div>
        </div>

        <div *ngIf="japanSelected == true && japanSelected != undefined" class="form-group row" [ngClass]="{'has-error': (supplyInfoForm.get('japanZipcode').invalid  && f.submitted)}">
          <label for="delPlantName" class="col-sm-6 col-form-label">{{'ZIPCODE' | translate}}
            <!-- <span class="required">*</span> -->
          </label>
          <div class="col-sm-6">
            <input type="text" class="form-control" formControlName="japanZipcode" placeholder="{{'Enter Zip code' | translate}}"
              (blur)="autoFilled(1)" (input)="autoFilled(1,null)">
            <!-- <div *ngIf="supplyInfoForm.controls.japanZipcode.invalid && japanSelected == true && noValue == false "
              class="required-error">{{'Zip Code pattern is 111-1111' | translate}}</div> -->
          </div>
        </div>

        <div class="form-group row" [ngClass]="{'has-error': supplyInfoForm.get('supplierAddress').invalid && f.submitted }">
          <label for="" class="col-sm-6 col-form-label">{{'PERFECTURE' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-sm-6">
            <input type="text" class="form-control" [(ngModel)]="zipDetailsAddress" formControlName="supplierAddress">
            <errors [control]="supplyInfoForm.controls.supplierAddress"></errors>
            <div *ngIf="supplyInfoForm.get('supplierAddress').invalid && f.submitted" class="required-error">{{'FieldRequired'
              | translate}}</div>
          </div>
        </div>

        <div class="form-group row" [ngClass]="{'has-error': supplyInfoForm.get('supplierCity').invalid && f.submitted }">
          <label for="" class="col-sm-6 col-form-label">{{'CITY' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-sm-6">
            <input type="text" class="form-control" formControlName="supplierCity">
            <errors [control]="supplyInfoForm.controls.supplierCity"></errors>
            <div *ngIf="supplyInfoForm.get('supplierCity').invalid && f.submitted" class="required-error">{{'FieldRequired'
              | translate}}</div>
          </div>
        </div>

        <div class="form-group row" [ngClass]="{'has-error': supplyInfoForm.get('supplierStreet').invalid && f.submitted }">
          <label for="" class="col-sm-6 col-form-label">{{'STREET' | translate}}
            <span class="required">*</span>
          </label>
          <div class="col-sm-6">
            <input type="text" class="form-control" formControlName="supplierStreet">
            <errors [control]="supplyInfoForm.controls.supplierStreet"></errors>
            <div *ngIf="supplyInfoForm.get('supplierStreet').invalid && f.submitted" class="required-error">{{'FieldRequired'
              | translate}}</div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group row pad-tb-10" [ngClass]="{'has-error':  supplyInfoForm.get('supplierNameJP').invalid && f.submitted }">
          <label for="" class="col-sm-6 col-form-label">{{'SUPPNAME[Jap]' | translate}}</label>

          <div class="col-sm-6">
            <input type="text" class="form-control" formControlName="supplierNameJP">
            <errors [control]="supplyInfoForm.controls.supplierNameJP"></errors>
            <div *ngIf="supplyInfoForm.get('supplierNameJP').invalid && f.submitted" class="required-error">{{'FieldRequired'
              | translate}}</div>
          </div>
        </div>
        <div class="dta_sub_title pad-btm-10">{{'CONTACTPERSON' | translate}}</div>
        <div class="form-group row">
          <label for="" class="col-sm-6 col-form-label">{{'LASTNAME' | translate}}</label>
          <div class="col-sm-6">
            <input type="text" class="form-control" formControlName="supplierLastName">
          </div>
        </div>
        <div class="form-group row">
          <label for="" class="col-sm-6 col-form-label">{{'FIRSTNAME' | translate}}</label>
          <div class="col-sm-6">
            <input type="text" class="form-control" formControlName="supplierFirstName">
          </div>
        </div>
        <div class="form-group row">
          <label for="delPlantName" class="col-sm-6 col-form-label">{{'EMAIL' | translate}}</label>
          <div class="col-sm-6">
            <input type="email" class="form-control" formControlName="supplierEmail">
          </div>
        </div>
        <div class="form-group row">
          <label for="" class="col-sm-6 col-form-label">{{'TELEPHONENO' | translate}}</label>
          <div class="col-sm-6">
            <input type="text" class="form-control" formControlName="supplierTelephone">
          </div>
        </div>
      </div>
    </div>

    <div class="dta_title">{{'SUPPLYINFO' | translate}}</div>
    <div class="dta_title_brd1" >
    </div>
      <div formArrayName="items" *ngFor="let item of items.controls; let i = index;">
        <div [formGroupName]="i">
          <div class="dta_sub_title pad-btm-10 pad-top-20">{{'SHIPPINGPOINT' | translate}}
            <span class="pad-lft-10" *ngIf="i==0">1</span>
            <span class="pad-lft-10" *ngIf="i>0">{{i+1}}</span>
            <div class="del-btn float-right" *ngIf="i != 0">
              <button class="btn btn-dark" (click)="removeItem(i)">{{'REMOVESHIPPINGPOINT' | translate}}</button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group row">
                <label for="delPlantName" class="col-sm-6 col-form-label">{{'NAME' | translate}}</label>
                <div class="col-sm-6">
                  <input type="text" class="form-control" formControlName="supplyName">
                </div>
              </div>
              <div class="form-group row" [ngClass]="{'has-error': item.get('supplyCountry').invalid && f.submitted }">
                <label for="supplyCountry" class="col-sm-6 col-form-label">{{'COUNTRY' | translate}}
                  <span class="required">*</span>
                </label>
                <div class="col-sm-6">
                  <select class="form-control" (ngModelChange)="selectedSupplyCountry($event)" formControlName="supplyCountry">
                    <option value="" selected>Select</option>
                    <option *ngFor="let n of country" [value]="n.name">{{n.name}}</option>
                  <!-- <option *ngFor="let n of countryOpt" [attr.value]="n">{{n}}</option> -->
                  </select>
                  <errors [control]="item.controls.supplyCountry"></errors>
                  <div *ngIf="item.get('supplyCountry').invalid && f.submitted" class="required-error">{{'FieldRequired'
                    | translate}}</div>
                </div>
              </div>
              <div class="form-group row" [ngClass]="{'has-error': item.get('supplyJapanZipcode').invalid && f.submitted }">
                <label for="supplyZipCode" class="col-sm-6 col-form-label">{{'ZIPCODE' | translate}}
                <!-- <span class="required">*</span> -->
                </label>
              <!-- Other Country -->
                <div class="col-sm-6" *ngIf="!supplyJapanSelected">
                  <input type="text" class="form-control" (keypress)="numberOnly($event)" formControlName="supplyJapanZipcode"
                    placeholder="{{'Enter Zip code' | translate}}">
                <div *ngIf="item.get('supplyJapanZipcode').invalid && supplyJapanSelected == false" class="required-error">{{'Zip Code should be 8 digit long' | translate}}</div>
                </div>
              <!-- Japan Country -->
                <div class="col-sm-6" *ngIf="supplyJapanSelected">
                  <input type="text" (blur)="autoFilled(2,i)" class="form-control" (input)="autoFilled(2,i);checkIsJapanZip($event.target.value, i)"
                    formControlName="supplyJapanZipcode" placeholder="{{'Enter Zip code' | translate}}">
                  <div *ngIf=" item.get('supplyJapanZipcode').invalid && f.submitted" class="required-error">{{'FieldRequired'
                    | translate}}</div>
                  <div *ngIf="detailsAddress[i].error" class="required-error">{{'Zip Code pattern is 111-1111' |
                    translate}}</div>
                </div>
              </div>
              <div class="form-group row" [ngClass]="{'has-error': item.get('supplyAddress').invalid && f.submitted }">
                <label for="" class="col-sm-6 col-form-label">{{'PERFECTURE' | translate}}
                  <span class="required">*</span>
                </label>
                <div class="col-sm-6">
                  <input type="text" class="form-control" formControlName="supplyAddress">
                  <errors [control]="item.controls.supplyAddress"></errors>
                  <div *ngIf="item.get('supplyAddress').invalid && f.submitted" class="required-error">{{'FieldRequired'
                    | translate}}</div>
                </div>
              </div>

              <div class="form-group row" [ngClass]="{'has-error': item.get('supplyCity').invalid && f.submitted }">
                <label for="" class="col-sm-6 col-form-label">{{'CITY' | translate}}
                  <span class="required">*</span>
                </label>
                <div class="col-sm-6">
                  <input type="text" class="form-control" formControlName="supplyCity">
                <!-- <select class="form-control" formControlName="supplyCity">
                  <option value="">Select</option>
                  <option *ngFor="let n of cityOpt" [value]="n">{{n}}</option>
                </select> -->
                  <errors [control]="item.controls.supplyCity"></errors>
                  <div *ngIf="item.get('supplyCity').invalid && f.submitted" class="required-error">{{'FieldRequired' |
                    translate}}</div>
                </div>
              </div>

              <div class="form-group row" [ngClass]="{'has-error': item.get('supplyStreet').invalid && f.submitted }">
                <label for="" class="col-sm-6 col-form-label">{{'STREET' | translate}}
                  <span class="required">*</span>
                </label>
                <div class="col-sm-6">
                  <input type="text" class="form-control" formControlName="supplyStreet">
                  <errors [control]="item.controls.supplyStreet"></errors>
                  <div *ngIf="item.get('supplyStreet').invalid && f.submitted" class="required-error">{{'FieldRequired' |
                    translate}}</div>
                </div>
              </div>
              <div class="form-group row">
                <label for="" class="col-sm-6 col-form-label">{{'TIMEWINDOWFROM' | translate}}</label>
                <div class="col-sm-6">
                <!-- <input type="text" class="form-control" formControlName="supplyTimeWindow"> -->
                  <select class="form-control" formControlName="supplyTimeWindow">
                    <option value="">Select</option>
                    <option *ngFor="let opt of supplyTimeOpt" [value]="opt">{{opt}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group row">
                <label for="" class="col-sm-6 col-form-label">{{'SPCONTACT' | translate}}</label>
                <div class="col-sm-6">
                  <input type="text" class="form-control" formControlName="supplySpContact">
                </div>
              </div>
              <div class="form-group row">
                <label for="delPlantName" class="col-sm-6 col-form-label">{{'DELIVERYTIMELEAD' | translate}}</label>
                <div class="col-sm-6 deliveryTime">
                  <ngx-timepicker-field  [format]="24"  [controlOnly]="true" formControlName="supplyDeliveryTime"></ngx-timepicker-field>

                </div>
              </div>
              <div class="form-group row">
                <label for="" class="col-sm-6 col-form-label">{{'PRIORNOTICE' | translate}}</label>
                <div class="col-sm-6">
                  <select class="form-control" formControlName="supplyAsnAvailability">
                    <option value="">Select</option>
                    <option *ngFor="let n of aslOpt" [value]="n">{{n}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div class="text-right mar-btm-20">
      <button type="button" [disabled]="AdminDisableBtn" class="btn btn-dark-brd" (click)="addItem()">{{'ADDMORESHIPOINT'
        | translate}}</button>
    </div>


    <div class="row pad-tb-30 top_dash_brd action_section">
      <div class="col-md-6 text-center">
        <button type="submit" class="btn btn-dark" (click)="saveSupplyForm()" [disabled]="disableSubmit" id="supplyInfoSave">{{'SAVE'
          | translate}}</button>
      </div>
      <div class="col-md-6 text-left">
        <button type="button" class="btn btn-dark" (click)="saveNextSupplyForm()" [disabled]="disableSubmit" id="supplyInfoNext">{{'NEXT'
          | translate}}</button>
      </div>
    </div>
  </section>
</form>


<!-- Part Number History Modal -->

<ng-template #history let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Part Number History</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Page Under Construction ..</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">Close</button>
  </div>
</ng-template>